import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { EditSplitMergeService } from 'app/services/edit-split-merge.service';
import { EditToolService, NeutralColumn } from 'app/services/edit-tool.service';
import { FloatPopupService } from 'app/services/float-popup.service';
import { MainDataService } from 'app/services/main-data.service';
import { ResolutionQcService } from 'app/services/resolution-qc.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-line-merge',
  templateUrl: './line-merge.component.html',
  styleUrls: ['./line-merge.component.css']
})
export class LineMergeComponent implements OnInit, OnDestroy {

	selectionList: any[];
	selectedLine;

	primaryRec;
	mergedRec = {};

	cols: NeutralColumn[];

	nguidCol: {
		prop: string;
		name: string;
	};
	private globalIdCol: string;
	fromLeftColName: string;
	fromRightColName: string;
	toLeftColName: string;
	toRightColName: string;
	parityLeftColName: string;
	parityRightColName: string;

	// private mergeLineSub: Subscription;
	private selectedRecordsSub: Subscription;
	constructor(
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService,
		private editToolService: EditToolService,
		private floatPopupService: FloatPopupService,
		private mainDataService: MainDataService,
		private resoQcService: ResolutionQcService,
		private splitMergeService: EditSplitMergeService
	) { }

	apply() {
		this.splitMergeService.mergeLineBS.next({
			mergedRec: this.mergedRec,
			ids: this.selectionList.map(i => i[this.globalIdCol]),
			isApply: true
		})
		this.splitMergeService.mergeToolBS.next({
			action: 'stop'
		});
		// this.floatPopupService.closePopup(LineMergeComponent);
	}
	cancel() {
		this.splitMergeService.mergeToolBS.next({
			action: 'stop'
		});
		// this.floatPopupService.closePopup(LineMergeComponent);
	}

	setPrimary() {
		const skipAttrs = [this.globalIdCol, this.fromLeftColName, this.fromRightColName, this.toLeftColName, this.toRightColName, this.parityLeftColName, this.parityRightColName];
		Object.keys(this.selectedLine).forEach(k => {
			if (skipAttrs.indexOf(k) === -1) {
				this.mergedRec[k] = this.selectedLine[k];
			}
		})
	}

	private updateMeasureAndParity() {
		const fromLeftList = this.selectionList.map(i => i[this.fromLeftColName]);
		const fromRightList = this.selectionList.map(i => i[this.fromRightColName]);
		const toLeftList = this.selectionList.map(i => i[this.toLeftColName]);
		const toRightList = this.selectionList.map(i => i[this.toRightColName]);
		this.mergedRec[this.fromLeftColName] = Math.min(...fromLeftList);
		this.mergedRec[this.fromRightColName] = Math.min(...fromRightList);
		this.mergedRec[this.toLeftColName] = Math.max(...toLeftList);
		this.mergedRec[this.toRightColName] = Math.max(...toRightList);
		this.mergedRec[this.parityLeftColName] = this.resoQcService.getParity(this.mergedRec[this.fromLeftColName], this.mergedRec[this.toLeftColName]);
		this.mergedRec[this.parityRightColName] = this.resoQcService.getParity(this.mergedRec[this.fromRightColName], this.mergedRec[this.toRightColName]);
	}

	ngOnInit() {
		this.globalIdCol = this.attrIndexService.rcUuidCol; 
		this.nguidCol = {
			prop: `grd_${this.attrIndexService.nguidCol.toLowerCase()}`,
			name: this.attrIndexService.nguidCol
		};
		this.fromLeftColName = this.attrIndexService.fromAddrLeftColName;
		this.fromRightColName = this.attrIndexService.fromAddrRightColName;
		this.toLeftColName = this.attrIndexService.toAddrLeftColName;
		this.toRightColName = this.attrIndexService.toAddrRightColName;
		this.parityLeftColName = this.attrIndexService.parityLeftColName;
		this.parityRightColName = this.attrIndexService.parityRightColName;

		// this.mergeLineSub = this.splitMergeService.mergeLineBS.subscribe(data => {

		// });
		this.selectedRecordsSub = this.activityService.selectedRecordsBS.subscribe(data => {
			if (!data || !data.ids) {
				this.selectionList = [];
				this.selectedLine = null;
				this.mergedRec = {};
				return;
			}
			this.selectionList = data.ids.map(id => this.mainDataService.getDataAttrs(id));
			// const newSelection = data.ids.map(id => this.mainDataService.getDataAttrs(id));
			// if (!this.selectionList.length) {
			// 	this.selectionList = newSelection;
			// } else {
			// 	const newList = [];
			// 	newSelection.forEach(i => {
			// 		const line = this.selectionList.find(l => l[this.globalIdCol] === i[this.globalIdCol]);
			// 		if (line) {
			// 			newList.push(line);
			// 		} else {
			// 			newList.push(i)
			// 		}
			// 	})
			// }
			if (this.selectedLine) {
				this.selectedLine = this.selectionList.find(l => l[this.globalIdCol] === this.selectedLine[this.globalIdCol]);
			}
			if (!this.selectedLine) {
				this.selectedLine = this.selectionList[0];
			}
			this.updateMeasureAndParity();
		});
		this.cols = this.editToolService.transformLeftRightColumnsToNeutral(this.mainDataService.currentColumns);
	}
	ngOnDestroy(): void {
		// this.mergeLineSub.unsubscribe();
		this.selectedRecordsSub.unsubscribe();

	}
}
